<template>
    <div class="stage-page">
        <div class="container">
            <div class="row mt-5">
                <div class="col-12">
                    <h1>Map of stage</h1>
                </div>
                <div class="col-12">
                    <stage-map :stage="stage" class="mt-4"></stage-map>
                </div>
            </div>
            <div class="row">
                <div class="col-12 mt-4">
                    <h1>Step description</h1>
                    <hr>
                    <p>{{stage.description}}</p>
                </div>
                <div class="col-12 mt-5" v-if="stage.how_to_guide.service">
                    <h1>Travel guide</h1>
                    <hr>
                    <div class="row">
                        <div class="col-lg-8">
                            <div class="guide-item" v-for="(statement, index) in stage.how_to_guide.service.statements" :key="index">
                                <p>{{ statement.body }}</p>
                                <hr>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div v-if="stage.how_to_guide.service.website" class="useful-links">
                                <h2>Useful links</h2>
                                <a class="d-inline-block mt-3" :href="stage.how_to_guide.service.website" target="_blank" data-toggle="modal" data-target="#leaveSiteModal">
                                    <strong>Link to {{stage.how_to_guide.service.name}} website</strong>
                                </a>
                                <svg class="ml-2 d-inline-block" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.00714 3.98438H1V15.9844H13.0143V10.0146" stroke="#4547BF" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M4.00293 13L16.0172 1" stroke="#4547BF" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M10.0098 1H16.0169V7" stroke="#4547BF" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <!-- Modal -->
                            <div class="modal fade" id="leaveSiteModal" tabindex="-1" role="dialog" aria-labelledby="leaveSiteModalLabel" aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered" role="document">
                                    <div class="modal-content px-5 py-4">
                                        <div class="modal-body text-center">
                                            <div class="message">
                                                <h1 class="color-secondary-blue">Are you sure?</h1>
                                                <h3>You are about to leave {{this.siteName}} to visit {{ stage.how_to_guide.service.website }}, are you sure you want to do this?</h3>
                                            </div>
                                            <button @click="openExternalSite" type="button" class="btn btn-primary px-4 py-3 mt-4 mx-auto w-75 rounded-pill d-flex align-items-center justify-content-center">
                                                <h3 class="d-inline mb-0">Yes, I'm sure</h3>
                                                <svg-icon class="ml-3 forward-icon d-none d-md-block" name="arrow-right" aria-label="arrow right icon" width="24" height="auto"></svg-icon>
                                            </button>
                                            <button type="button" data-dismiss="modal" class="btn btn-outline-secondary px-4 py-3 my-3 mx-auto w-75 rounded-pill d-flex align-items-center justify-content-center">
                                                <h3 class="d-inline mb-0">No, take me back</h3>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="stage.timetable">
                                <a class="d-inline-block mt-3" href="#" data-toggle="modal" data-target="#timetableModal">
                                    <strong>Timetable for this service</strong>
                                </a>
                                <svg class="ml-2 d-inline-block" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.00714 3.98438H1V15.9844H13.0143V10.0146" stroke="#4547BF" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M4.00293 13L16.0172 1" stroke="#4547BF" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M10.0098 1H16.0169V7" stroke="#4547BF" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <!-- Modal -->
                    <div class="modal fade" id="timetableModal" tabindex="-1" role="dialog" aria-labelledby="timetableModal" aria-hidden="true">
                        <div class="modal-dialog modal-xl">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="timetableModal">Timetable</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <timetable v-if="stage.timetable" :timetable="stage.timetable"></timetable>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StageMap from '@/components/StageMap.vue'
import Timetable from '@/components/Timetable.vue'

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]


export default {
    name: 'stage-details',
    props: ['stage'],
    components: {
        StageMap,
        Timetable,
    },
    data() {
        return {
            showDirectionsOffset: 1000,
            siteName: whitelabel.shortTitle,
        }
    },
    methods: {
        goBack() {
            this.$emit('goBack')
        },
        navigate(type) {
            this.$emit('navigate', type)
        },
        openExternalSite() {
            window.open(this.stage.how_to_guide.service.website)
        },
    },
}
</script>
